import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { ContentSection } from 'components/data/ContentSection/ContentSection'
import { TextField } from 'components/inputs/TextField/TextField'
import { KnowledgeBaseVisibilitySelect } from 'components/data/VisibilityTypeSelect/KnowledgeBaseVisibilitySelect/KnowledgeBaseVisibilitySelect'
import { UploadImageField } from 'components/inputs/UploadFilesField/UploadFilesField'

const selectStyles = css`
  min-width: 200px;
`

const StyledKnowledgeBaseVisibilitySelect = styled(KnowledgeBaseVisibilitySelect)`
  ${selectStyles}
`

const StyledTextField = styled(TextField)`
  width: 100%;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 800px;
`

const InfoSection = styled(ContentSection)`
  flex: 1;
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
  min-width: 200px;
`

const StyledUploadFilesButton = styled(UploadImageField)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
`

const FilePreviewSection = styled.div`
  display: flex;
  flex-direction: column;
`

const FilePreviewSectionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const FilePreviewSectionError = styled.p`
  ${({ theme }) => css`
    margin-top: 0;
    font-size: 14px;
    color: ${theme.palette.error.main};
  `}
`

export {
  StyledTextField as TextField,
  Form,
  InfoSection,
  StyledKnowledgeBaseVisibilitySelect as KnowledgeBaseVisibilitySelect,
  StyledUploadFilesButton as UploadFilesButton,
  FilePreviewSection,
  FilePreviewSectionRow,
  FilePreviewSectionError,
}
